//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { ReactNode } from 'react';
import styled from '@emotion/styled';

type StatusCircleProps = {
  children: ReactNode;
  type: 'success' | 'warning' | 'error';
};

export const StatusCircle = ({ children, type }: StatusCircleProps) => <Circle type={type}>{children}</Circle>;

type CircleProps = {
  type: string;
};
const Circle = styled.div<CircleProps>`
  border: 1px solid transparent;
  font-weight: bold;
  display: inline-flex;
  height: 25px;
  width: 25px;
  padding: 5px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 3px;
  line-height: 1;

  &:last-child {
    margin-right: 0;
  }

  background: ${({ theme, type }) => {
    switch (type) {
      case 'success':
        return `${theme.palette.success.main}1a`;
      case 'warning':
        return `${theme.palette.warning.main}1a`;
      case 'error':
        return `${theme.palette.error.main}1a`;
      default:
        return '#eee';
    }
  }};
  border-color: ${({ theme, type }) => {
    switch (type) {
      case 'success':
        return theme.palette.success.main;
      case 'warning':
        return theme.palette.warning.main;
      case 'error':
        return theme.palette.error.main;
      default:
        return 'transparent';
    }
  }};
  color: ${({ theme, type }) => {
    switch (type) {
      case 'success':
        return theme.palette.success.main;
      case 'warning':
        return theme.palette.warning.main;
      case 'error':
        return theme.palette.error.main;
      default:
        return 'white';
    }
  }};
`;
